(ns common.transaction-process.config
  (:require
   [common.transaction-process.templates.registry :as template-registry]
   #?(:cljs [cljs.reader :as edn])
   #?(:clj [clojure.edn :as edn])))

(defn resolve-template
  "Resolve the template config for a transaction process. Always dynamic: reads the
   latest template from the registry by `template-kw`, so template fixes/improvements
   propagate to in-flight processes (pre-prod single-tenant; see spec §5.7). The
   burned-config snapshot was removed — the versioning seam (keying the registry on
   `[template-kw version]` via a reserved `:transaction-process/template-version`
   attribute) stays unbuilt until a prod fidelity requirement appears."
  [{:keys [template-kw]}]
  (template-registry/get-template template-kw))

(defn parse-vehicle-config
  [raw]
  (cond
    (map? raw) raw
    (string? raw) (try
                    (edn/read-string raw)
                    (catch #?(:clj Exception :cljs :default) _e
                      {}))
    :else {}))

(defn templates-for-vehicle
  "Return template-kw keywords for all enabled templates in vehicle config."
  [vehicle-config]
  (->> (:tp-config/available-templates vehicle-config)
       (filter :enabled?)
       (mapv :template-kw)))
